import type { ReactNode } from "react";

import cc from "classcat";

import styles from "./TransactionDetailsPanel.module.scss";

// "nds-typescale--upper" doesn't exist in the installed NDS build, so the title fell back to
// sentence case instead of the Figma all-caps label; styles.sectionTitle covers it instead.
const SECTION_TITLE_CLASSES = cc([
  styles.sectionTitle,
  "fontColor--secondary fontWeight--bold fontSize--xs",
]);

interface PanelSectionHeadingProps {
  title: string;
  /** Content for the right of the heading line, e.g. a save status. */
  accessory?: ReactNode;
}

/**
 * A details panel section heading.
 *
 * The shell renders this for any section carrying a `title`. A section needing an accessory renders
 * it instead, because the accessory's state lives in the section body and the shell draws the title
 * as a sibling of that body. Keeping both paths here is what stops the heading treatment being
 * redefined per section.
 */
const PanelSectionHeading = ({
  title,
  accessory,
}: PanelSectionHeadingProps) => {
  if (!accessory) {
    return (
      <p className={cc([SECTION_TITLE_CLASSES, "margin--bottom--xs"])}>
        {title}
      </p>
    );
  }

  return (
    <div className={cc([styles.heading, "margin--bottom--xs"])}>
      <p className={SECTION_TITLE_CLASSES}>{title}</p>
      {accessory}
    </div>
  );
};

export default PanelSectionHeading;
